import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import MultiselectTags from 'Components/Organisms/MultiselectTags/MultiselectTags';

export default function RHFSelectMultipleTags({ name, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <MultiselectTags {...field} error={error?.message} {...other} />
            )}
        />
    );
}

RHFSelectMultipleTags.propTypes = {
    name: PropTypes.string.isRequired,
};
